import React from "react";

import i18n from "../../../i18n";

import { Tag } from "@blueprintjs/core";

import { userColors, userIcons } from "../../../utils/mef";
import { CCManagement } from "../UserManagement/CreditCardManagement";

export default function CreditCardTag(props) {
  const [open, handle] = React.useState(false);

  if (props.id !== undefined && props.id !== null && props.id.replace(/\s+/g, '') !== "")
    return (
      <span>
        <Tag
          icon={userIcons[1]}
          key="cc"
          style={{ backgroundColor: userColors[1] }}
          onClick={() => handle(true)}
          interactive={true}
        >
          {i18n.t("userType1")} n°{props.id}
        </Tag>
        {open ? (
          <CCManagement
            server={props.server}
            id={props.id.trim()}
            onClose={() => {
              handle(false)
            }}
            onUpdate={() => {
              handle(false)
            }}
            parkLookup={props.parkLookup}
            deviceLookup={props.deviceLookup}
          />) : null}
      </span>
    );
  else return null;
}